module.exports = __webpack_public_path__ + "static/media/Sync.f560df0c.svg";